import React from "react";
import "../css/Footer.css";

function FreeShipping() {
  return (
    <div className="pd-pre-footer">
      <div className="pd-pre-footer-content">
        <div className="pd-shipping">
          <svg
            className="amin-shipping-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="1" y="3" width="15" height="13" rx="1" />
            <path d="M16 8h4l3 4v5h-7V8z" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
          <h1>Free Shipping</h1>
          <div>
            We're making it easy to shop from home by providing FREE standard
            shipping on all India orders – no minimums or exclusions
          </div>
        </div>
        <div className="pd-purpose">
          <div className="pd-purpose-title">
            AMINII: Timeless elegance inspired by Pakistani designs
          </div>
          <p>
            At AMINII, we believe a beautiful design is only as good as the fabric and finishing behind it. That’s why every piece is carefully chosen for its timeless Pakistani design, premium fabrics, and exceptional finishing.

We don’t compromise on design fabric & finishing 

If you’re looking for Pakistani-inspired designs that feel premium, elegant, and made to last — you’re in the right place.
          </p>
        </div>
      </div>
    </div>
  );
}

export default FreeShipping;
